import { render, staticRenderFns } from "./CustomDateAreaPicker.vue?vue&type=template&id=12caf43a&scoped=true&"
import script from "./CustomDateAreaPicker.vue?vue&type=script&lang=js&"
export * from "./CustomDateAreaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12caf43a",
  null
  
)

export default component.exports